import { Text } from '@wework/dieter-ui'
import React from 'react'
import _ from 'lodash'
import parseISO from 'date-fns/parseISO'
import format from 'date-fns/format'
import StatusTag, { SpaceStatus } from '../../components/StatusTag'
import withConfiguration from '../../hoc/withConfiguration'

function Hold({
  space,
  border = false,
  containerStyle = {},
  configuration,
}: any) {
  if (!space) {
    return null
  }
  const { reservable } = space
  if (!reservable) {
    return null
  }

  const { officeHold } = reservable
  if (!officeHold) {
    return null
  }

  const { spacestationBaseUrl } = configuration

  let holdNote = (officeHold && officeHold.note) || ''

  if (officeHold && officeHold.note) {
    holdNote = `${holdNote.substring(0, 100)}...`
  }

  return (
    <div
      style={{
        position: 'relative',
        padding: '1em',
        marginTop: 8,
        borderRadius: '.25rem',
        border: border ? '1px solid #E6E6E6' : 0,
        ...containerStyle,
      }}
    >
      <div style={{ display: 'flex', flexWrap: 'nowrap', marginBottom: 8 }}>
        <StatusTag status={SpaceStatus.ONHOLD} />
      </div>
      {officeHold.companyName ? (
        <Text
          href={`${spacestationBaseUrl}companies/${officeHold.companyUUID}`}
          target="_blank"
          primary
          as="a"
          rel="noopener noreferrer"
          style={{
            fontSize: 16,
            lineHeight: '28px',
            marginBottom: 12,
          }}
        >
          {`${officeHold.companyName}`}
        </Text>
      ) : (
        <Text
          style={{
            fontWeight: 'bold',
            margin: 0,
            marginTop: 12,
          }}
          size="small"
        >{`${officeHold.contactInfoName}`}</Text>
      )}

      <Text size="tiny" color="grey">
        Expires {format(parseISO(officeHold.endsAt), 'MMM dd, yyyy, p')}
      </Text>
      <div style={{ marginTop: 16, marginBottom: 16 }}>
        <Text size="small" primary>
          By{' '}
          {`${_.get(officeHold, 'createdBy.firstName', '')} ${_.get(
            officeHold,
            'createdBy.lastName',
            ''
          )}`}
        </Text>
      </div>
      <Text size="tiny" style={{ fontWeight: 'bold' }}>
        Hold note
      </Text>

      {holdNote
        ? holdNote.split('\n').map((text, i) => {
            return (
              // eslint-disable-next-line react/no-array-index-key
              <Text size="small" key={`${i}-${text}`}>
                {text}
              </Text>
            )
          })
        : '-'}
    </div>
  )
}

export default withConfiguration()(Hold)
